export enum AdverseCreditState {
  satisfied = 'satisfied',
  active = 'active',
}

export enum AdverseCreditDeclaration {
  declared = 'declared',
  undeclared = 'undeclared',
}

export enum AdverseCreditType {
  ccj = 'ccj',
  ivaBankruptcy = 'ivaBankruptcy',
  other = 'other',
}

export type AdverseCredit = {
  id?: string
  caseNumber: string
  type: AdverseCreditType
  state: AdverseCreditState
  declaration: AdverseCreditDeclaration
  amount: number
  courtDate: string
}
